var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_12072)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99983 2.77855C5.73791 3.83933 4.15426 4.53101 2.4165 4.68724V8.66658C2.4165 9.88938 3.0051 11.0484 3.94312 12.0501C4.80574 12.9713 5.92293 13.7125 6.99983 14.1866C8.07673 13.7125 9.19397 12.9713 10.0566 12.0501C10.9946 11.0484 11.5832 9.88938 11.5832 8.66658V4.68727C9.84517 4.53162 8.26153 3.83916 6.99983 2.77855ZM11.6748 4.69497C11.6747 4.69496 11.6749 4.69497 11.6748 4.69497V4.69497ZM7.91311 1.58625C7.39101 1.13791 6.60905 1.1388 6.08733 1.58558C5.0266 2.49555 3.68327 3.08314 2.20751 3.19957C1.45875 3.25837 0.916504 3.89218 0.916504 4.60791V8.66658C0.916504 10.3891 1.74456 11.8968 2.84821 13.0754C3.9526 14.2548 5.38142 15.1603 6.72128 15.6963C6.90009 15.7678 7.09957 15.7678 7.27838 15.6963C8.61825 15.1603 10.0471 14.2548 11.1515 13.0754C12.2551 11.8968 13.0832 10.3891 13.0832 8.66658V4.60791C13.0832 3.89209 12.5408 3.2582 11.7919 3.19955C10.3167 3.08376 8.97396 2.49622 7.91311 1.58625Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_12072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4,
    height: 16,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.1dced95a5442961f37106501bd6e7144.svg";
export { ForwardRef as ReactComponent };